import React from 'react'

import PrimaryHeader from '../../../components/primary-header'
import Icon from '../../../components/icon'
import Ranking from '../../../components/ranking'
import HomeSection from '../../../components/home-section'
import DoctorCard from '../../../components/doctor-card'
import SearchDoctors from '../../../components/search-doctors'
import WelcomeModal from '../../../components/welcome-modal'
import FaqButton from '../../../components/faq-button'

import * as S from './styles'

import IProps from './props'

import LinkBuilder from '../../../helpers/helper-link-builder'

import userIMG from '../../../assets/png/user-profile.png'

const HomeContractor = ({
  user,
  recentContacts,
  contractedDoctors,
  handleSearch,
  isModalOpen,
  handleModalClose,
  hasNewNotification,
  hasNewMessage,
  specialties,
  rankingData,
  states,
  loadCities,
}: IProps) => (
  <S.Container>
    <WelcomeModal
      isModalOpen={isModalOpen}
      handleCloseModal={handleModalClose}
    />
    <PrimaryHeader>
      <S.HeaderContent>
        <S.Avatar
          src={user.imgUrl ? LinkBuilder.buildAssetsUrl(user.imgUrl) : userIMG}
          alt="Avatar"
        />
        <S.HeaderTexts>
          <S.HeaderText>{`Olá, ${user.firstName}`}</S.HeaderText>
          <S.HeaderSubText to="/contractors/profile">
            Ver meu perfil
            {' '}
            <Icon name="arrow-right" />
          </S.HeaderSubText>
        </S.HeaderTexts>
        <S.IconsContainer>
          <S.IconWrapper to="/contractors/chats">
            <Icon name="message" />
            {hasNewMessage && <S.IconTag />}
          </S.IconWrapper>
          <S.IconWrapper to="/notifications/CONTRATANTE">
            <Icon name="bell" />
            {hasNewNotification && <S.IconTag />}
          </S.IconWrapper>
        </S.IconsContainer>
      </S.HeaderContent>
    </PrimaryHeader>
    <SearchDoctors
      onSearch={handleSearch}
      specialtyList={specialties}
      stateList={states}
      loadCities={loadCities}
    />
    <HomeSection
      title="Contatos recentes"
      link="/contractors/contacts"
      showLink={recentContacts.length > 0}
    >
      {recentContacts.length === 0 && (
        <p>Você ainda não fez contato com nenhum médico.</p>
      )}

      {recentContacts.map((doctor: any) => (
        <DoctorCard
          key={`recent-contacts-list-${doctor.id}`}
          name={doctor.name}
          location={doctor.address.city}
          linkChat={doctor.linkChat}
          linkProfile={doctor.linkProfile}
          hasNewMessage={doctor.hasNewMessage}
        />
      ))}
    </HomeSection>
    <FaqButton />
    <Ranking rankingData={rankingData} />
    <HomeSection
      title="Histórico de médicos contratados"
      link="/contractors/contracts"
      showLink={contractedDoctors.length > 0}
    >
      {contractedDoctors.length === 0 && (
        <p>Você ainda não contratou nenhum médico.</p>
      )}

      {contractedDoctors.map((doctor) => (
        <DoctorCard
          key={`contracted-doctors-list-${doctor.id}`}
          name={doctor.name}
          location={doctor.address.city}
          linkProfile={doctor.linkProfile}
          showIcon={false}
        />
      ))}
    </HomeSection>
  </S.Container>
)

export default HomeContractor
